import { create } from 'zustand';

/**
 * 素材 @メンションの UI 状態共有ストア (docs/features/material-at-mention-plan.md)。
 *
 * バッジ (A, B, C…) は常時表示するとノイズになるため、いずれかの入力欄で
 * @メンションポップアップが開いている間だけ SelectedAssetsPanel に表示する。
 * ポップアップ (useMaterialMention) は複数インスタンスが同時にマウントされ得るため
 * boolean ではなく開数カウントで管理する。
 */
interface MentionUiState {
  /** 現在開いている @メンションポップアップの数。 */
  openPopupCount: number;
  incrementOpenPopup: () => void;
  decrementOpenPopup: () => void;
}

export const useMentionUiStore = create<MentionUiState>((set) => ({
  openPopupCount: 0,
  incrementOpenPopup: () => set((s) => ({ openPopupCount: s.openPopupCount + 1 })),
  decrementOpenPopup: () => set((s) => ({ openPopupCount: Math.max(0, s.openPopupCount - 1) })),
}));
